import React, { useEffect, useState } from "react";
import { useHistory, useParams, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import Box from "@mui/material/Box";
import {
	Grid,
	Typography,
	Button,
	TextField,
	MenuItem,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	Accordion,
	AccordionSummary,
	AccordionDetails
} from "@mui/material";
import { ExpandMore } from "@mui/icons-material";
import Layout from "../../components/Wrappers/Layout";
import { Card, Alert } from "reactstrap";
import {
	resetGetVoucherRedeemDetails,
	getVoucherRedeemDetailsList
} from "../../redux/actions/getVoucherRedeemDetailsAction";
import { makeStyles } from "@mui/styles";
import BackButton from "../../components/BackButton/BackButton";
import SOLogout from "../../components/Logout/SOLogout";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";

const useStyles = makeStyles({
	table: {
		minWidth: 650
	}
});

const RedeemDetails = () => {
	const classes = useStyles();
	const location = useLocation();
	const trackingId = location.search.split("?userId=")[1];
	// console.log(trackingId);

	const dispatch = useDispatch();
	// const partnerloginUser = useSelector(({ login }) => login);
	// var authToken = partnerloginUser.data.AuthToken;

	const regenerateTokenRes = useSelector(
		({ regenerateToken }) => regenerateToken
	);
	// console.log("regenerateTokenRes", regenerateTokenRes);
	var authToken = regenerateTokenRes.data.AuthToken;

	const [getVoucherRedeemDetailsStatus, SetgetVoucherRedeemDetailsStatus] =
		useState(false);

	const [getVoucherRedeemDetailsArray, SetgetVoucherRedeemDetailsArray] =
		useState([]);

	const getVoucherRedeemDetailsRes = useSelector(
		({ getVoucherRedeemDetails }) => getVoucherRedeemDetails
	);

	const getRedeemDetailsReqApi = () => {
		SetgetVoucherRedeemDetailsStatus(true);
		const getRedeemDetailsReq = {
			loginDetails: {
				walletOwnerId: regenerateTokenRes.data.partnerId || ""
			},
			voucherTransVO: {
				trackingId: trackingId
			}
		};

		return dispatch(
			getVoucherRedeemDetailsList(getRedeemDetailsReq, authToken)
		);
	};

	useEffect(() => {
		if (regenerateTokenRes.data.status == "success") {
			getRedeemDetailsReqApi();
		}
	}, [regenerateTokenRes.data.status]);

	useEffect(() => {
		if (getVoucherRedeemDetailsStatus) {
			if (getVoucherRedeemDetailsRes.data.status == "success") {
				SetgetVoucherRedeemDetailsArray(
					getVoucherRedeemDetailsRes.data.voucherTransVO
				);
			}
			if (getVoucherRedeemDetailsRes.data.status == "Failed") {
				SetgetVoucherRedeemDetailsArray(getVoucherRedeemDetailsRes.data);
				if (
					getVoucherRedeemDetailsRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getVoucherRedeemDetailsRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			if (getVoucherRedeemDetailsRes.data.status == "failed") {
				SetgetVoucherRedeemDetailsArray(getVoucherRedeemDetailsRes.data);
				if (
					getVoucherRedeemDetailsRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getVoucherRedeemDetailsRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			if (getVoucherRedeemDetailsRes.data.status == "NOT FOUND") {
				SetgetVoucherRedeemDetailsArray(getVoucherRedeemDetailsRes.data);
			}
		}
	}, [getVoucherRedeemDetailsRes.data.status]);

	// console.log("getVoucherRedeemDetailsArray");
	// console.log(getVoucherRedeemDetailsArray);
	// console.log("getVoucherRedeemDetailsArray");

	return (
		<>
			<Layout>
				<BackButton />
				<div
					style={{
						background: "",
						paddingBottom: "1rem",
						paddingTop: "0.5rem"
					}}
				>
					<Box marginLeft={3} marginRight={3} paddingBottom={2}>
						<div
							style={{
								marginTop: "2rem"
							}}
						>
							<Accordion>
								<AccordionSummary
									expandIcon={<ExpandMore />}
									aria-controls="panel1a-content"
									id="panel1a-header"
								>
									<Typography className="themeText">
										Merchant Details
									</Typography>
								</AccordionSummary>
								<AccordionDetails style={{ display: "unset" }}>
									<TableContainer component={Paper}>
										{
											// getVoucherTransactionDetailsArray &&
											//   getVoucherTransactionDetailsArray.customerDetailsVO && (
											<Table
												className={classes.table}
												aria-label="a dense table"
												style={{ whiteSpace: "nowrap" }}
											>
												<TableHead>
													<TableRow className="tableHeaderColor">
														<TableCell
															align="center"
															style={{ fontWeight: "bold", color: "white" }}
														>
															Merchant Id{" "}
														</TableCell>
														{/* <TableCell
															align="center"
															style={{ fontWeight: "bold", color: "white" }}
														>
															Merchant Customer Id{" "}
														</TableCell> */}
														<TableCell
															align="center"
															style={{ fontWeight: "bold", color: "white" }}
														>
															Customer Id
														</TableCell>
														<TableCell
															align="center"
															style={{ fontWeight: "bold", color: "white" }}
														>
															Company Name
														</TableCell>
														<TableCell
															align="center"
															style={{ fontWeight: "bold", color: "white" }}
														>
															Website
														</TableCell>
														<TableCell
															align="center"
															style={{ fontWeight: "bold", color: "white" }}
														>
															IP Address
														</TableCell>
													</TableRow>
												</TableHead>

												<TableBody>
													{getVoucherRedeemDetailsArray &&
														[]
															.concat(getVoucherRedeemDetailsArray)
															.map((row, index) => (
																<TableRow key={index}>
																	<TableCell align="center">
																		{row.toId ? row.toId : "-"}
																	</TableCell>
																	{/* <TableCell align="center">
																		{row.contactName ? row.contactName : "-"}
																	</TableCell> */}
																	<TableCell align="center">
																		{row.customerId ? row.customerId : "-"}
																	</TableCell>
																	<TableCell align="center">
																		{row.merchantCompany
																			? row.merchantCompany
																			: "-"}
																	</TableCell>
																	<TableCell align="center">
																		{row.merchantWebsite
																			? row.merchantWebsite
																			: "-"}
																	</TableCell>
																	<TableCell align="center">
																		{row.email ? row.email : "-"}
																	</TableCell>
																</TableRow>
															))}
												</TableBody>
											</Table>
											// )
										}
									</TableContainer>
								</AccordionDetails>
							</Accordion>
						</div>
						{/* <TableContainer component={Paper}>
          <BackButton />
          <Typography
            variant="body1"
            style={{
              textAlign: "center",
              margin: "10px 0",
              color: "#01367e",
              fontSize: "1.4rem",
            }}
          >
            Merchant Details
          </Typography>

          {
            // getVoucherTransactionDetailsArray &&
            //   getVoucherTransactionDetailsArray.customerDetailsVO && (
            <Table
              className={classes.table}
              aria-label="a dense table"
              style={{ whiteSpace: "nowrap" }}
            >
              <TableHead>
                <TableRow style={{ background: "#00b9f5" }}>
                  <TableCell
                    align="center"
                    style={{ fontWeight: "bold", color: "white" }}
                  >
                    Merchant Id{" "}
                  </TableCell>
                  <TableCell
                    align="center"
                    style={{ fontWeight: "bold", color: "white" }}
                  >
                    Merchant Customer Id{" "}
                  </TableCell>
                  <TableCell
                    align="center"
                    style={{ fontWeight: "bold", color: "white" }}
                  >
                    Customer Id
                  </TableCell>
                  <TableCell
                    align="center"
                    style={{ fontWeight: "bold", color: "white" }}
                  >
                    Company Name
                  </TableCell>
                  <TableCell
                    align="center"
                    style={{ fontWeight: "bold", color: "white" }}
                  >
                    Website
                  </TableCell>
                  <TableCell
                    align="center"
                    style={{ fontWeight: "bold", color: "white" }}
                  >
                    IP Address
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {getVoucherRedeemDetailsArray &&
                  []
                    .concat(
                      getVoucherRedeemDetailsArray
                    )
                    .map((row, index) => (
                      <TableRow key={row.index}>
                        <TableCell align="center">{row.customerId ? row.customerId : "-"}</TableCell>
                        <TableCell align="center">
                          {row.contactName ? row.contactName : "-"}
                        </TableCell>
                        <TableCell align="center">{row.country ? row.country : "-"}</TableCell>
                        <TableCell align="center">{row.email ? row.email : "-"}</TableCell>
                        <TableCell align="center">{row.country ? row.country : "-"}</TableCell>
                        <TableCell align="center">{row.email ? row.email : "-"}</TableCell>
                      </TableRow>
                    ))}
              </TableBody>
            </Table>
            // )
          }
        </TableContainer> */}

						<div
							style={{
								marginTop: "2rem"
							}}
						>
							<Accordion>
								<AccordionSummary
									expandIcon={<ExpandMore />}
									aria-controls="panel1a-content"
									id="panel1a-header"
								>
									<Typography className="themeText">Redeem Details</Typography>
								</AccordionSummary>
								<AccordionDetails style={{ display: "unset" }}>
									<TableContainer component={Paper}>
										<Table
											className={classes.table}
											aria-label="a dense table"
											style={{ whiteSpace: "nowrap" }}
										>
											<TableHead>
												<TableRow className="tableHeaderColor">
													<TableCell
														align="center"
														style={{ fontWeight: "bold", color: "white" }}
													>
														Tracking Id{" "}
													</TableCell>
													<TableCell
														align="center"
														style={{ fontWeight: "bold", color: "white" }}
													>
														TimeStamp
													</TableCell>
													<TableCell
														align="center"
														style={{ fontWeight: "bold", color: "white" }}
													>
														Redeem Amount
													</TableCell>
													<TableCell
														align="center"
														style={{ fontWeight: "bold", color: "white" }}
													>
														Redeem Currency
													</TableCell>
													<TableCell
														align="center"
														style={{ fontWeight: "bold", color: "white" }}
													>
														Merchant Amount{" "}
													</TableCell>
													<TableCell
														align="center"
														style={{ fontWeight: "bold", color: "white" }}
													>
														Merchant Currency
													</TableCell>
													<TableCell
														align="center"
														style={{ fontWeight: "bold", color: "white" }}
													>
														Order Amount
													</TableCell>
													<TableCell
														align="center"
														style={{ fontWeight: "bold", color: "white" }}
													>
														Order Currency
													</TableCell>

													<TableCell
														align="center"
														style={{ fontWeight: "bold", color: "white" }}
													>
														Order ID{" "}
													</TableCell>
													<TableCell
														align="center"
														style={{ fontWeight: "bold", color: "white" }}
													>
														Status
													</TableCell>
													<TableCell
														align="center"
														style={{ fontWeight: "bold", color: "white" }}
													>
														Rule Triggered
													</TableCell>
													<TableCell
														align="center"
														style={{ fontWeight: "bold", color: "white" }}
													>
														Reason
													</TableCell>
												</TableRow>
											</TableHead>

											<TableBody>
												{getVoucherRedeemDetailsArray &&
													[]
														.concat(getVoucherRedeemDetailsArray)
														.map((row, index) => (
															<TableRow key={row.index}>
																<TableCell align="center">
																	{row.trackingId ? row.trackingId : "-"}
																</TableCell>
																<TableCell align="center">
																	{row.timestamp ? row.timestamp : "-"}
																</TableCell>
																<TableCell align="center">
																	{row.orderDescription
																		? row.orderDescription
																		: "-"}
																</TableCell>
																<TableCell align="center">-</TableCell>
																<TableCell align="center">
																	{row.refundAmount ? row.refundAmount : "-"}
																</TableCell>
																<TableCell align="center">
																	{row.merchantCurrency
																		? row.merchantCurrency
																		: "-"}
																</TableCell>
																<TableCell align="center">
																	{row.orderAmount ? row.orderAmount : "-"}
																</TableCell>
																<TableCell align="center">
																	{row.orderCurrency ? row.orderCurrency : "-"}
																</TableCell>
																<TableCell align="center">-</TableCell>
																{/* <TableCell align="center">{row.OrderID ? row.orderAmount : "-"}</TableCell> */}
																<TableCell align="center">
																	{row.status ? row.status : "-"}
																</TableCell>
																<TableCell align="center">-</TableCell>
																<TableCell align="center">
																	{row.reason ? row.reason : "-"}
																</TableCell>
															</TableRow>
														))}
											</TableBody>
										</Table>
									</TableContainer>
								</AccordionDetails>
							</Accordion>
						</div>

						{/* <TableContainer component={Paper} style={{ marginTop: "15px" }}>
              <Typography
                variant="body1"
                style={{
                  textAlign: "center",
                  margin: "10px 0",
                  color: "#01367e",
                  fontSize: "1.4rem",
                }}
              >
                Redeem Details
              </Typography>
             
              <Table
                className={classes.table}
                aria-label="a dense table"
                style={{ whiteSpace: "nowrap" }}
              >
                <TableHead>
                  <TableRow style={{ background: "#00b9f5" }}>
                    <TableCell
                      align="center"
                      style={{ fontWeight: "bold", color: "white" }}
                    >
                      Tracking Id{" "}
                    </TableCell>
                    <TableCell
                      align="center"
                      style={{ fontWeight: "bold", color: "white" }}
                    >
                      TimeStamp
                    </TableCell>
                    <TableCell
                      align="center"
                      style={{ fontWeight: "bold", color: "white" }}
                    >
                      Redeem Amount
                    </TableCell>
                    <TableCell
                      align="center"
                      style={{ fontWeight: "bold", color: "white" }}
                    >
                      Redeem Currency
                    </TableCell>
                    <TableCell
                      align="center"
                      style={{ fontWeight: "bold", color: "white" }}
                    >
                      Merchant Amount{" "}
                    </TableCell>
                    <TableCell
                      align="center"
                      style={{ fontWeight: "bold", color: "white" }}
                    >
                      Merchant Currency
                    </TableCell>
                    <TableCell
                      align="center"
                      style={{ fontWeight: "bold", color: "white" }}
                    >
                      Order Amount
                    </TableCell>
                    <TableCell
                      align="center"
                      style={{ fontWeight: "bold", color: "white" }}
                    >
                      Order Currency
                    </TableCell>

                    <TableCell
                      align="center"
                      style={{ fontWeight: "bold", color: "white" }}
                    >
                      Order ID{" "}
                    </TableCell>
                    <TableCell
                      align="center"
                      style={{ fontWeight: "bold", color: "white" }}
                    >
                      Status
                    </TableCell>
                    <TableCell
                      align="center"
                      style={{ fontWeight: "bold", color: "white" }}
                    >
                      Rule Triggered
                    </TableCell>
                    <TableCell
                      align="center"
                      style={{ fontWeight: "bold", color: "white" }}
                    >
                      Reason
                    </TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {getVoucherRedeemDetailsArray &&
                    []
                      .concat(getVoucherRedeemDetailsArray)
                      .map((row, index) => (
                        <TableRow key={row.index}>
                          <TableCell align="center">{row.trackingId ? row.trackingId : "-"}</TableCell>
                          <TableCell align="center">{row.trackingId ? row.trackingId : "-"}</TableCell>
                          <TableCell align="center">
                            {row.orderDescription ? row.orderDescription : "-"}
                          </TableCell>
                          <TableCell align="center">-</TableCell>
                          <TableCell align="center">
                            {row.refundAmount ? row.refundAmount : "-"}
                          </TableCell>
                          <TableCell align="center">
                            {row.voucherCurrency ? row.voucherCurrency : "-"}
                          </TableCell>
                          <TableCell align="center">{row.status ? row.status : "-"}</TableCell>
                          <TableCell align="center">{row.timestamp ? row.timestamp : "-"}</TableCell>
                        </TableRow>
                      ))}
                </TableBody>
              </Table>
            </TableContainer> */}

						<div
							style={{
								marginTop: "2rem"
							}}
						>
							<Accordion>
								<AccordionSummary
									expandIcon={<ExpandMore />}
									aria-controls="panel1a-content"
									id="panel1a-header"
								>
									<Typography className="themeText">Voucher Details</Typography>
								</AccordionSummary>
								<AccordionDetails style={{ display: "unset" }}>
									<TableContainer component={Paper}>
										{getVoucherRedeemDetailsArray &&
											getVoucherRedeemDetailsArray.voucherListRequestVOList && (
												<Table
													className={classes.table}
													aria-label="a dense table"
													style={{ whiteSpace: "nowrap" }}
												>
													<TableHead>
														<TableRow className="tableHeaderColor">
															<TableCell
																align="center"
																style={{ fontWeight: "bold", color: "white" }}
															>
																Voucher Id{" "}
															</TableCell>
															<TableCell
																align="center"
																style={{ fontWeight: "bold", color: "white" }}
															>
																Voucher Number
															</TableCell>
															<TableCell
																align="center"
																style={{ fontWeight: "bold", color: "white" }}
															>
																Voucher Type
															</TableCell>
															<TableCell
																align="center"
																style={{ fontWeight: "bold", color: "white" }}
															>
																Voucher Status
															</TableCell>
															<TableCell
																align="center"
																style={{ fontWeight: "bold", color: "white" }}
															>
																Voucher Amount
															</TableCell>
															<TableCell
																align="center"
																style={{ fontWeight: "bold", color: "white" }}
															>
																Voucher Currency
															</TableCell>
															<TableCell
																align="center"
																style={{ fontWeight: "bold", color: "white" }}
															>
																Creation Date
															</TableCell>
															<TableCell
																align="center"
																style={{ fontWeight: "bold", color: "white" }}
															>
																Activation Date
															</TableCell>
															<TableCell
																align="center"
																style={{ fontWeight: "bold", color: "white" }}
															>
																Redeem Date
															</TableCell>
															<TableCell
																align="center"
																style={{ fontWeight: "bold", color: "white" }}
															>
																Expiry Date
															</TableCell>
														</TableRow>
													</TableHead>

													<TableBody>
														{getVoucherRedeemDetailsArray.voucherListRequestVOList &&
															[]
																.concat(
																	getVoucherRedeemDetailsArray.voucherListRequestVOList
																)
																.map((row, index) => (
																	<TableRow key={index}>
																		<TableCell align="center">
																			{row.voucherId ? row.voucherId : "-"}
																		</TableCell>
																		<TableCell align="center">
																			{row.voucherNumber
																				? row.voucherNumber
																				: "-"}
																		</TableCell>
																		<TableCell align="center">
																			{row.voucherType ? row.voucherType : "-"}
																		</TableCell>
																		<TableCell align="center">
																			{row.status ? row.status : "-"}
																		</TableCell>
																		<TableCell align="center">
																			{row.amount ? row.amount : "-"}
																		</TableCell>
																		<TableCell align="center">
																			{row.currency ? row.currency : "-"}
																		</TableCell>
																		<TableCell align="center">
																			{row.creationDate
																				? row.creationDate
																				: "-"}
																		</TableCell>
																		<TableCell align="center">
																			{row.activationDate
																				? row.activationDate
																				: "-"}
																		</TableCell>
																		<TableCell align="center">
																			{row.redeemDate ? row.redeemDate : "-"}
																		</TableCell>
																		<TableCell align="center">
																			{row.expiryDate ? row.expiryDate : "-"}
																		</TableCell>
																	</TableRow>
																))}
													</TableBody>
												</Table>
											)}
									</TableContainer>
								</AccordionDetails>
							</Accordion>
						</div>

						{/* <TableContainer component={Paper} style={{ marginTop: "15px" }}>
              <Typography
                variant="body1"
                style={{
                  textAlign: "center",
                  margin: "10px 0",
                  color: "#01367e",
                  fontSize: "1.4rem",
                }}
              >
                Voucher Details
              </Typography>

              {getVoucherRedeemDetailsArray &&
                getVoucherRedeemDetailsArray.voucherListRequestVOList && (
                  <Table
                    className={classes.table}
                    aria-label="a dense table"
                    style={{ whiteSpace: "nowrap" }}
                  >
                    <TableHead>
                      <TableRow style={{ background: "#00b9f5" }}>
                        <TableCell
                          align="center"
                          style={{ fontWeight: "bold", color: "white" }}
                        >
                          Voucher Id{" "}
                        </TableCell>
                        <TableCell
                          align="center"
                          style={{ fontWeight: "bold", color: "white" }}
                        >
                          Voucher Number
                        </TableCell>
                        <TableCell
                          align="center"
                          style={{ fontWeight: "bold", color: "white" }}
                        >
                          Voucher Type
                        </TableCell>
                        <TableCell
                          align="center"
                          style={{ fontWeight: "bold", color: "white" }}
                        >
                          Voucher Status
                        </TableCell>
                        <TableCell
                          align="center"
                          style={{ fontWeight: "bold", color: "white" }}
                        >
                          Voucher Amount
                        </TableCell>
                        <TableCell
                          align="center"
                          style={{ fontWeight: "bold", color: "white" }}
                        >
                          Voucher Currency
                        </TableCell>
                        <TableCell
                          align="center"
                          style={{ fontWeight: "bold", color: "white" }}
                        >
                          Creation Date
                        </TableCell>
                        <TableCell
                          align="center"
                          style={{ fontWeight: "bold", color: "white" }}
                        >
                          Activation Date
                        </TableCell>
                        <TableCell
                          align="center"
                          style={{ fontWeight: "bold", color: "white" }}
                        >
                          Redeem Date
                        </TableCell>
                        <TableCell
                          align="center"
                          style={{ fontWeight: "bold", color: "white" }}
                        >
                          Expiry Date
                        </TableCell>
                      </TableRow>
                    </TableHead>

                    <TableBody>
                      {getVoucherRedeemDetailsArray.voucherListRequestVOList &&
                        []
                          .concat(
                            getVoucherRedeemDetailsArray.voucherListRequestVOList
                          )
                          .map((row, index) => (
                            <TableRow key={index}>
                              <TableCell align="center">{row.voucherId ? row.voucherId : "-"}</TableCell>
                              <TableCell align="center">
                                {row.voucherNumber ? row.voucherNumber : "-"}
                              </TableCell>
                              <TableCell align="center">
                                {row.voucherType ? row.voucherType : "-"}
                              </TableCell>
                              <TableCell align="center">
                                {row.voucherType.status ? row.voucherType.status : "-"}
                              </TableCell>
                              <TableCell align="center">{row.amount ? row.amount : "-"}</TableCell>
                              <TableCell align="center">{row.currency ? row.currency : "-"}</TableCell>
                              <TableCell align="center">
                                {row.creationDate ? row.creationDate : "-"}
                              </TableCell>
                              <TableCell align="center">
                                {row.activationDate ? row.activationDate : "-"}
                              </TableCell>
                              <TableCell align="center">{row.redeemDate ? row.redeemDate : "-"}</TableCell>
                              <TableCell align="center">{row.expiryDate ? row.expiryDate : "-"}</TableCell>
                            </TableRow>
                          ))}
                    </TableBody>
                  </Table>
                )}
            </TableContainer> */}

						<div
							style={{
								marginTop: "2rem"
							}}
						>
							<Accordion>
								<AccordionSummary
									expandIcon={<ExpandMore />}
									aria-controls="panel1a-content"
									id="panel1a-header"
								>
									<Typography className="themeText">History</Typography>
								</AccordionSummary>
								<AccordionDetails style={{ display: "unset" }}>
									<TableContainer component={Paper}>
										{getVoucherRedeemDetailsArray &&
											getVoucherRedeemDetailsArray.voucherHistoryVoList && (
												<Table
													className={classes.table}
													aria-label="a dense table"
													style={{ whiteSpace: "nowrap" }}
												>
													<TableHead>
														<TableRow className="tableHeaderColor">
															<TableCell
																align="center"
																style={{ fontWeight: "bold", color: "white" }}
															>
																Action
															</TableCell>
															<TableCell
																align="center"
																style={{ fontWeight: "bold", color: "white" }}
															>
																TimeStamp
															</TableCell>
															<TableCell
																align="center"
																style={{ fontWeight: "bold", color: "white" }}
															>
																Redeem Amount{" "}
															</TableCell>
															<TableCell
																align="center"
																style={{ fontWeight: "bold", color: "white" }}
															>
																Redeem Currency
															</TableCell>
															<TableCell
																align="center"
																style={{ fontWeight: "bold", color: "white" }}
															>
																Remark
															</TableCell>
															<TableCell
																align="center"
																style={{ fontWeight: "bold", color: "white" }}
															>
																Action Executor Name{" "}
															</TableCell>
															<TableCell
																align="center"
																style={{ fontWeight: "bold", color: "white" }}
															>
																Reason
															</TableCell>
														</TableRow>
													</TableHead>

													<TableBody>
														{getVoucherRedeemDetailsArray.voucherHistoryVoList &&
															[]
																.concat(
																	getVoucherRedeemDetailsArray.voucherHistoryVoList
																)
																.map((row, index) => (
																	<TableRow key={row.walletId}>
																		<TableCell align="center">-</TableCell>
																		<TableCell align="center">
																			{row.timeStamp ? row.timeStamp : "-"}
																		</TableCell>
																		<TableCell align="center">
																			{row.redeemAmount
																				? row.redeemAmount
																				: "-"}
																		</TableCell>
																		<TableCell align="center">
																			{row.redeemCurrency
																				? row.redeemCurrency
																				: "-"}
																		</TableCell>
																		<TableCell align="center">-</TableCell>
																		<TableCell align="center">
																			{row.actionExecutorName
																				? row.actionExecutorName
																				: "-"}
																		</TableCell>
																		<TableCell align="center">
																			{row.reason ? row.reason : "-"}
																		</TableCell>
																	</TableRow>
																))}
													</TableBody>
												</Table>
											)}
									</TableContainer>
								</AccordionDetails>
							</Accordion>
						</div>

						{/* <TableContainer component={Paper} style={{ marginTop: "15px" }}>
              <Typography
                variant="body1"
                style={{
                  textAlign: "center",
                  margin: "10px 0",
                  color: "#01367e",
                  fontSize: "1.4rem",
                }}
              >
                History
              </Typography>

              {getVoucherRedeemDetailsArray &&
                getVoucherRedeemDetailsArray.voucherHistoryVoList && (
                  <Table
                    className={classes.table}
                    aria-label="a dense table"
                    style={{ whiteSpace: "nowrap" }}
                  >
                    <TableHead>
                      <TableRow style={{ background: "#00b9f5" }}>
                        <TableCell
                          align="center"
                          style={{ fontWeight: "bold", color: "white" }}
                        >
                          Action
                        </TableCell>
                        <TableCell
                          align="center"
                          style={{ fontWeight: "bold", color: "white" }}
                        >
                          TimeStamp
                        </TableCell>
                        <TableCell
                          align="center"
                          style={{ fontWeight: "bold", color: "white" }}
                        >
                          Redeem Amount{" "}
                        </TableCell>
                        <TableCell
                          align="center"
                          style={{ fontWeight: "bold", color: "white" }}
                        >
                          Redeem Currency
                        </TableCell>
                        <TableCell
                          align="center"
                          style={{ fontWeight: "bold", color: "white" }}
                        >
                          Remark
                        </TableCell>
                        <TableCell
                          align="center"
                          style={{ fontWeight: "bold", color: "white" }}
                        >
                          Action Executor Name{" "}
                        </TableCell>
                        <TableCell
                          align="center"
                          style={{ fontWeight: "bold", color: "white" }}
                        >
                          Reason
                        </TableCell>
                      </TableRow>
                    </TableHead>

                    <TableBody>
                      {getVoucherRedeemDetailsArray.voucherHistoryVoList &&
                        []
                          .concat(getVoucherRedeemDetailsArray.voucherHistoryVoList)
                          .map((row, index) => (
                            <TableRow key={row.walletId}>
                              <TableCell align="center">-</TableCell>
                              <TableCell align="center">{row.timeStamp ? row.timeStamp : "-"}</TableCell>
                              <TableCell align="center">
                                {row.redeemAmount ? row.redeemAmount : "-"}
                              </TableCell>
                              <TableCell align="center">
                                {row.redeemCurrency ? row.redeemCurrency : "-"}
                              </TableCell>
                              <TableCell align="center">
                                -
                              </TableCell>
                              <TableCell align="center">
                                {row.actionExecutorName ? row.actionExecutorName : "-"}
                              </TableCell>
                              <TableCell align="center">{row.reason ? row.reason : "-"}</TableCell>
                            </TableRow>
                          ))}
                    </TableBody>
                  </Table>
                )}
            </TableContainer> */}
					</Box>
				</div>
			</Layout>
		</>
	);
};

export default RedeemDetails;
